import { radarFile, type Level, type MapId } from "@69ly/maps";

// Vite turns each radar into a hashed asset URL at build time.
const files = import.meta.glob("../../../../packages/maps/radars/*.webp", {
  eager: true,
  query: "?url",
  import: "default",
}) as Record<string, string>;

/** URL of a map's radar image. */
export function radarUrl(map: MapId, level: Level = "upper"): string {
  const name = radarFile(map, level);
  const entry = Object.entries(files).find(([path]) => path.endsWith(`/${name}`));
  return entry ? entry[1] : "";
}
